const recentpincdrcolumndata = [
  { id: "starttime", title: "Time", default: true },
  { id: "pin", title: "PIN", default: true },
  { id: "src", title: "From", default: true },
  { id: "destination", title: "To", default: true },
  { id: "sessiontime", title: "Dur", default: true },
  { id: "sessionprice", title: "Cost", default: true },
];
export default recentpincdrcolumndata;
